import React from 'react';
import { ICommandBarItemProps, IconButton } from '@fluentui/react';
import { useGetStorefrontOrdersQuery } from '../../../store/endpoints/StorefrontSettingsEndpoints';
import Widget from '../../Common/Widgets/Widget';

interface IStorefrontProcurementWidgetProps {
    onStorefrontOrderClick: (id: string) => void;
    onProcurementOrderClick: (id: string) => void;
}

const StorefrontProcurementWidget: React.FC<IStorefrontProcurementWidgetProps> = (props) => {
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(25);
    const orders = useGetStorefrontOrdersQuery({ conditions: {
        page,
        pageSize,
        sortBy: 'createDate',
        sortDirection: 'desc',
        includedFields: [
            'id',
            'orderNumber',
            'createDate',
            'total',
            'costTotal',
            'emailAddress',
            'status',
        ]
    } })

    const refetch = () => {
        orders.refetch();
    }

    const rightCommands: ICommandBarItemProps[] = [
        {
            key: 'refresh',
            text: 'Refresh',
            iconOnly: true,
            iconProps: { iconName: 'Refresh' },
            onClick: refetch
        }
    ]

    return (<Widget
        header='Storefront Orders'
        rightCommands={rightCommands}
        size={'large'}
        grow={1}
        >
        <table style={{width: '100%'}} className='data-table' data-testid='storefront-orders-widget'>
            <thead>
                <tr>
                    <th>Order Number</th>
                    <th>Date</th>
                    <th>Email</th>
                    <th>Total</th>
                    <th>Cost</th>
                    <th>Profit</th>
                    <th>Status</th>
                    <th>Order</th>
                </tr>
            </thead>
            <tbody>
                {orders.data?.items.map(order => (
                    <tr key={order.id}>
                        <td>{order.orderNumber}</td>
                        <td>{new Date(order.createDate).toLocaleDateString()}</td>
                        <td>{order.emailAddress}</td>
                        <td>${order.total?.toFixed(2)}</td>
                        <td>${order.costTotal?.toFixed(2)}</td>
                        <td>${(order.total && order.costTotal ? (order.total - order.costTotal).toFixed(2) : '0.00')}</td>
                        <td>{order.status}</td>
                        <td>
                            <IconButton
                                iconProps={{ iconName: 'View' }}
                                title="View Order"
                                ariaLabel="View Order"
                                onClick={() => props.onStorefrontOrderClick(order.id)}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </Widget>);
}

export default StorefrontProcurementWidget;